import { PushNotifications } from '@capacitor/push-notifications'
import { Device } from '@capacitor/device'
import store from '../store'
import router from '../router'
import { captureException, captureMessage } from '@sentry/vue'
import { Browser } from '@capacitor/browser'

class PushNotificationService {
  constructor() {
    // No need to pass router as a parameter anymore
  }

  /**
   * Initialize push notification listeners
   */
  initializeListeners(tokenCallback, actionCallback, errorCallback, refreshCallback) {
    // Listen for incoming notifications
    PushNotifications.addListener('pushNotificationReceived', notification => {
      if (notification.data) {
        this.handleTokenRefresh()
        if (refreshCallback) refreshCallback()
      }
    })

    // Listen for notification actions
    PushNotifications.addListener('pushNotificationActionPerformed', 
      actionCallback || this.performNotificationAction.bind(this)
    )

    // Listen for registration events
    PushNotifications.addListener('registration', tokenCallback)
    
    // Listen for registration errors
    PushNotifications.addListener('registrationError', (err) => {
      console.error('Push notification registration error:', err)
      captureException(err)
      if (errorCallback) errorCallback(err)
    })
  }

  /**
   * Request permission for push notifications
   */
  async askForNotificationPermission() {
    try {        

      // Then check and request permissions
      let permStatus = await PushNotifications.checkPermissions()
      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions()
      }
      await PushNotifications.register()
      
      return permStatus
    } catch (error) {
      console.error('Error requesting push notification permission:', error)
      throw error
    }
  }

  /**
   * Handle notification actions
   */
  performNotificationAction(notificationData) {
    if (!notificationData.notification?.data?.action?.action) {
      return
    }

    switch (notificationData.notification.data.action.action) {
      case 'see_daily_dashboard':
        router.push({
          name: 'daily-dashboard'
        })
        break
      case 'see_habit_tracker':
        router.push({
          name: 'habit-tracker'
        })
        break
      case 'see_report':
        router.push({
          name: 'report'
        })
        break
      case 'see_period':
        router.push({
          name: 'period'
        })
        break
      case 'join_whatsapp_group':
        const whatsappUrl = notificationData.notification.data.action.params?.whatsapp_url
        if (whatsappUrl) {
          this.openWhatsAppGroup(whatsappUrl)
        }
        break
    }
    
    PushNotifications.removeDeliveredNotifications(notificationData.notification)
  }

  /**
   * Open WhatsApp group link
   */
  async openWhatsAppGroup(whatsappUrl) {
    try {
      // Try to open in WhatsApp first, then fallback to browser
      // await Browser.open({ 
      //   url: whatsappUrl,
      //   windowName: '_system'
      // })
      window.open(whatsappUrl, '_blank');

    } catch (error) {
      console.error('Error opening WhatsApp group:', error)
      captureException(error)
    }
  }

  /**
   * Handle token refresh
   */
  handleTokenRefresh() {
    return PushNotifications.register()
      .catch(err => {
        captureException(err)
      })
  }
}

export default PushNotificationService